import { Luscinia, luscinia } from "./luscinia";

// Use this to execute a function by name, used in select2 for adding custom formatting i.e. user image rendering
luscinia.getFunctionByName = function (functionName, context) {
    var args = [].slice.call(arguments).splice(2);
    var namespaces = functionName.split(".");
    var func = namespaces.pop();
    for (var i = 0; i < namespaces.length; i++) {
        context = context[namespaces[i]];
    }
    return context[func];
};

// Used for sizing modal dialog to screen height
luscinia.getPosition = function (element: HTMLElement) {
    var xPosition = 0;
    var yPosition = 0;

    while (element) {
        xPosition += element.offsetLeft - element.scrollLeft + element.clientLeft;
        yPosition += element.offsetTop - element.scrollTop + element.clientTop;
        element = element.offsetParent as HTMLElement;
    }
    return { x: xPosition, y: yPosition };
};

luscinia.getQueryParameterByKey = (key: string): string | null => {
    const params = new URLSearchParams(window.location.search);
    return params.get(key);
};

luscinia.SetCaretAtEnd = function (inputElement) {
    var elemLen = inputElement.value.length;
    // For IE Only
    if ((document as any).selection) {
        // Set focus
        inputElement.focus();
        // Use IE Ranges
        var oSel = (document as any).selection.createRange();
        // Reset position to 0 & then set at end
        oSel.moveStart('character', -elemLen);
        oSel.moveStart('character', elemLen);
        oSel.moveEnd('character', 0);
        oSel.select();
    }
    else if (inputElement.selectionStart || inputElement.selectionStart === 0) {
        // Firefox/Chrome
        inputElement.selectionStart = elemLen;
        inputElement.selectionEnd = elemLen;
        inputElement.focus();
    }
};

luscinia.objectifyForm = function (formObject) {
    //serialize data function
    var newObject = {};
    for (let key of formObject.keys()) {
        newObject[key] = formObject.get(key);
    }
    return newObject;
};

luscinia.isHTML = function (str) {
    var doc = new DOMParser().parseFromString(str, "text/html");
    return Array.from(doc.body.childNodes).some(node => node.nodeType === 1);
};

luscinia.clearFields = function (fieldNames: string[]): void {
    fieldNames.forEach(name => {
        const field: HTMLInputElement = document.querySelector(`input[name="${name}"]`);
        if (field.classList.contains(luscinia.css.ajaxSelect)) {
            $(field).val(null).trigger('change');
            return;
        }
        field.value = "";        
        setTimeout(() => {
            field.dispatchEvent(new Event('change'));
        }, 500);
    });
}